import { PlusIcon } from '@heroicons/react/outline';
import InformationTab from 'components/InformationTab';
import useActions from 'hooks/useActions';
import useSetFromOptions from 'hooks/useSetFromOptions';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';

function mapStateToProps(state) {
    return {
        tagGroups: state.vhsTags.tagGroups,
        page: state.vhsTags.page,
        per_page: state.vhsTags.per_page,
        total_pages: state.vhsTags.total_pages,
        total: state.vhsTags.total,
        brandsOptions: state.vhsBrands.brandsOptions,
    };
}

function TableSection({ tagGroup, navigate = function () {}, brandsSet = {} }) {
    const { VHS_SELECT_TAG_GROUP } = useActions();

    return (
        <section className="mt-8 mb-8 flex-col card-box p-4">
            <div className='flex flex-row'>
                <div className="flex flex-col w-1/12">
                    <span className="text-lg mr-4 uppercase">{tagGroup.name}</span>
                    <span className="text-primary-dark-color">
                        {brandsSet[tagGroup.brand_ident]}
                    </span>
                </div>
                <div className="tags-container-border tags-bg p-4 pt-2 pl-2 flex flex-wrap w-11/12 rounded-xl">
                
                {tagGroup.tags &&
                    tagGroup.tags.map((tag) => (
                        <button
                            key={`tag-${tag.id}`}
                            className="primary-color-box rounded-full tags-border p-4 h-6 flex items-center justify-center text-white ml-2 mt-2 text-sm"
                            onClick={() => {
                                VHS_SELECT_TAG_GROUP(tagGroup);
                                navigate(`/vhs/tags/tag/${tag.id}`);
                            }}
                        >
                            {tag.name}
                        </button>
                    ))}
                <button
                className="rounded-md circle-button mt-2 ml-2 h-10 w-10 flex items-center justify-center"
                onClick={() => {
                    VHS_SELECT_TAG_GROUP(tagGroup);
                    navigate(`/vhs/tags/tag/new/${tagGroup.id}`);
                }}
            >
                <PlusIcon color="white" height={15} />
                </button>
            </div>
            </div>
                <div className='flex justify-end mt-4'>
                <button
                    className="button"
                    onClick={() => {
                        VHS_SELECT_TAG_GROUP(tagGroup);
                        navigate(`/vhs/tags/group/${tagGroup.id}`);
                    }}
                >
                    Edit
                </button>
                </div>
        </section>
    );
}

const VHSTags = connect(mapStateToProps)(function (props) {
    const { tagGroups, brandsOptions } = props;
    const {
        VHS_FETCH_TAG_GROUPS_REQUEST,
        VHS_SELECT_TAG_GROUP,
        VHS_SELECT_TAG,
    } = useActions();

    const [brandsSet, setBrandsSet] = useSetFromOptions();

    const navigate = useNavigate();

    // eslint-disable-next-line
    const [sectionName, setSectionName] = useState('Tags');

    useEffect(() => {
        setBrandsSet(brandsOptions);
        // eslint-disable-next-line
    }, [brandsOptions]);

    useEffect(() => {
        VHS_SELECT_TAG(null);
        VHS_SELECT_TAG_GROUP(null);
        VHS_FETCH_TAG_GROUPS_REQUEST();
        // eslint-disable-next-line
    }, []);

    function dataTable() {
        return (
            <section>
                <div className='mt-8 mb-4 flex flex-row place-content-between'>
                <h1>All Tags and Groups</h1>
                <button
                    className="button add-button p-2 ml-4 text-white"
                    onClick={() => navigate(`/vhs/tags/group/new`)}
                >
                    Add a Tag Group
                </button>
                </div>
                {tagGroups.map((tagGroup) => (
                    <TableSection
                        key={'tag-group-' + tagGroup.id}
                        tagGroup={tagGroup}
                        navigate={navigate}
                        brandsSet={brandsSet}
                    />
                ))}
            </section>
        );
    }

    return (
        <section>
            <InformationTab
                dataTable={dataTable()}
                sectionName={sectionName}
                showFilters={false}
            />
        </section>
    );
});

export default VHSTags;
